import React from 'react';
import {
  Stack,
  Icon,
  Text,
} from '@piwikpro/ui-components';

export interface FailMessageProps {
  condensed?: boolean
  t: Function
}

export class FailMessage extends React.Component<FailMessageProps> {
  render() {
    const { condensed, t } = this.props;

    if (condensed) {
      return (
        <Stack
          verticalAlignment="center"
          spacing="extraNarrow"
        >
          <Stack.Item>
            <Icon
              color="red"
              name="exclamation-mark-circle"
              size="small"
            />
          </Stack.Item>
          <Stack.Item>
            <Text color="Red" dataId="TextStyle">
              {t('trackerSettings.load.failed')}
            </Text>
          </Stack.Item>
        </Stack>
      );
    }

    return (
      <Stack
        vertical
        horizontalAlignment="middle"
        verticalAlignment="center"
        spacing="extraWide"
      >
        <Stack.Item fill />
        <Stack.Item>
          <Stack
            vertical
            horizontalAlignment="middle"
          >
            <Stack.Item>
              <Icon
                color="red"
                name="exclamation-mark-circle"
                size="medium"
              />
            </Stack.Item>
            <Stack.Item>
              <Text color="Red" dataId="TextStyle">
                {t('trackerSettings.load.failed')}
              </Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item fill />
      </Stack>
    );
  }
}

export default FailMessage;
